/**
 * Maximum image size constants when uploading
 */

export const MAX_POST_IMAGE_SIZE = 3000000;

export const MAX_USER_COVER_IMAGE_SIZE = 5000000;

export const MAX_USER_PROFILE_IMAGE_SIZE = 2000000;
